import React, { useEffect } from "react";
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Form from 'react-bootstrap/Form'
import Alert from 'react-bootstrap/Alert'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import CardGroup from 'react-bootstrap/CardGroup'
import Carousel from 'react-bootstrap/Carousel'
import Modal from 'react-bootstrap/Modal'
import Dropdown from "react-bootstrap/Dropdown";
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import Table from 'react-bootstrap/Table'
import DropdownButton from "react-bootstrap/DropdownButton";
import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FiEdit, FiCopy, FiInfo, FiInstagram } from 'react-icons/fi'
import { GiPodiumWinner } from 'react-icons/gi'
import { FaUsers } from 'react-icons/fa';
import { GoPrimitiveDot } from "react-icons/go";
import { AiOutlineBug, AiOutlineLock } from "react-icons/ai";
import { RxEnter } from 'react-icons/rx'

import { GetLeagueByName, GetLeaguesByIds, GetUser, GetNextEvent, GetEvents, GetResults, GetDisabled, DisableEditing, GetOverallStandings, GetGlobalTopRiders } from '../../ApiRequests'
import { Helmet } from 'react-helmet'
import { FaFlagCheckered, FaCircle } from 'react-icons/fa';
import { RiArrowGoBackFill } from "react-icons/ri";
import { PieChart, Pie, Sector, ResponsiveContainer, Cell } from 'recharts';
import  WIN_Mobile from '../../Images/DMR/WIN_mobile.png'
import WIN  from '../../Images/DMR/WIN.png'

import './index.css'

const Dashboard = (props) => {

    const URL = process.env.REACT_APP_FRONT_END_URL

    const navigate = useNavigate()
    const [leagues, setLeagues] = useState([])
    const [userTeams, setUserTeams] = useState([])
    const [user, setUser] = useState({})
    const [nextEvent, setNextEvent] = useState({})
    const targetDate = new Date(nextEvent?.date); // Thursday, June 8th, 5pm CEST
    const [timeRemaining, setTimeRemaining] = useState('');

    const [showResults, setShowResults] = useState(false)
    const [results, setResults] = useState([])
    const [filteredResults, setFilteredResults] = useState([])
    const [genderFilter, setGenderFilter] = useState('Male')
    const [pointsFilter, setPointsFilter] = useState('Overall')
    const [event, setEvent] = useState({})
    const [editingDisabled, setEditingDisabled] = useState(true)
    const [events, setEvents] = useState([])
    const [overallStandings, setOverallStandings] = useState([])

    const [overallFilteredResults, setOverallFilteredResults] = useState([])
    const [overallGenderFilter, setOverallGenderFilter] = useState('Male')

    const [topRiderData, setTopRiderData] = useState([])
    const [topRiderChartData, setTopRiderChartData] = useState([])
    const [topRiderActiveIndex, setTopRiderActiveIndex] = useState(0)

    const GLOBAL_LEAGUEID = '64714ca81f37fec561936d38'

    const getGlobalLeague = async () => {
        const league = await GetLeagueByName('Global')
        if (!league) { return }
    }

    const getUser = async () => {
        const userId = localStorage.getItem('userID')
        const _user = await GetUser(userId)
        if (!_user) { return }
        if (!'data' in _user) { return }

        setUser(_user.data)
        return _user
    }

    const sampleData = [
        { name: 'Group A', value: 400 },
        { name: 'Group B', value: 300 }
    ]

    const getEditingDisabled = async () => {
        const res = await GetDisabled()
        if (!res || !res.data) {
            return
        }

        setEditingDisabled(res.data.disabled)
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();

        return `${year}-${month}-${day}`;
    }


    const getResults = async () => {
        const res = await GetResults();
        if (!res || !res.data) { return }

        const genderFilter = 'm';
        const sortedResults = res.data.sort((a, b) => b.total_points - a.total_points);
        setResults(sortedResults)

        const filtered = sortedResults.filter((result) => {
            const isGenderMatch = result.rider_gender === genderFilter;
            return isGenderMatch;
        });

        setFilteredResults([...filtered])
    }



    const getUserLeagues = async () => {
        //get all leagues that a user is apart of. 
        const userData = await getUser()
        if (!userData) { return }
        const _user = userData.data

        if (!_user) { return }
        if (!'teams' in _user) {
            console.log("NO TEAMS IN USER")
            return
        }

        if (!Array.isArray(_user.teams)) {
            console.log("USER TEAMS is not an array")
            return
        }

        setUserTeams(_user.teams)

        const leagueIds = _user.teams.map((team) => team.leagueId)
        const response = await GetLeaguesByIds(leagueIds)
        if (!response || !response.data) { return }
        setLeagues(response.data)
    }

    const JoinGlobalLeague = () => {
        navigate(`/CreateTeam?leagueId=${GLOBAL_LEAGUEID}`)
    }

    const goToLeague = (id) => {
        navigate(`/League?leagueId=${id}`)
    }

    const editMyTeam = (teamId, leagueId) => {
        navigate(`/EditTeam?teamId=${teamId}&leagueId=${leagueId}`)
    }


    const InfoIcon = () => {
        const renderTooltip = (props) => (
            <Tooltip id="button-tooltip" {...props}>
                To share private league with friends, send them the League URL below.
            </Tooltip>
        );

        return (
            <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
            >
                <Button className='mb-1 mx-0 px-1 py-0' variant="Link">
                    <FiInfo></FiInfo>
                </Button>
            </OverlayTrigger>)
    };


    const getNextEvent = async () => {
        const res = await GetNextEvent()
        if (!res) { return }
        setNextEvent(res.data)
    }

    // const getEvents = async () => {
    //     const _events = await GetEvents()
    //     console.log(_events)
    //     if (_events) {
    //         setEvents(_events.data)
    //     }
    // }

    const copyURL = async (url) => {
        navigator.clipboard.writeText(url)
            .then(() => {
                console.log('URL copied to clipboard', url);
            })
            .catch((error) => {
                console.error('Failed to copy URL:', error);
            });
    }

    const handleInstagramClick = () => {
        window.open('https://www.instagram.com/downhillmtbfantasy', '_blank');
    }

    const getTimeRemaining = () => {
        const now = new Date().getTime();
        const timeDifference = targetDate - now;

        if (timeDifference > 0) {
            const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

            return { days, hours, minutes, seconds, timeDifference };
        }

        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    };


    const handleFilter = (genderValue, pointsFilter, eventId) => {
        setGenderFilter(genderValue)
        setPointsFilter(pointsFilter)

        const genderFilter = genderValue === 'Male' ? 'm' : 'f';
        const filtered = results.filter((result) => {
            const isGenderMatch = (genderValue === 'All' || result.rider_gender === genderFilter) && (result.eventId === eventId);
            return isGenderMatch;
        });

        let filteredAndSortedRiders = [...filtered]
        if (pointsFilter == 'Qualifying') {
            filteredAndSortedRiders.sort((a, b) => b?.qualifying_points - a?.qualifying_points);

        } else if (pointsFilter == 'Semis') {
            filteredAndSortedRiders.sort((a, b) => b?.semis_points - a?.semis_points);

        } else if (pointsFilter == 'Finals') {
            filteredAndSortedRiders.sort((a, b) => b?.finals_points - a?.finals_points);

        } else if (pointsFilter == 'Overall') {
            filteredAndSortedRiders.sort((a, b) => b?.total_points - a?.total_points);

        }

        setFilteredResults(filteredAndSortedRiders);
    }


    const handleOverallFilter = (genderValue) => {
        setOverallGenderFilter(genderValue)

        const overallGenderFilter = genderValue === 'Male' ? 'm' : 'f';

        const filtered = overallStandings.filter((result) => {
            const isGenderMatch = (genderValue === 'All' || result.rider_gender === overallGenderFilter)
            return isGenderMatch;
        });

        let filteredAndSortedRiders = [...filtered]
        filteredAndSortedRiders.sort((a, b) => b?.total_points - a?.total_points);

        setOverallFilteredResults(filteredAndSortedRiders);
    }


    const getEvents = async () => {
        const res = await GetEvents()

        if (!res || !res.data) { return }
        setEvents(res.data)
    }

    const getOverallStandings = async () => {
        const res = await GetOverallStandings()

        if (!res || !res?.data) { return }

        const overallGenderFilter = 'm';
        const sortedResults = res.data.sort((a, b) => b.total_points - a.total_points);
        setOverallStandings(sortedResults)

        const filtered = sortedResults.filter((result) => {
            const isGenderMatch = result.rider_gender === overallGenderFilter;
            return isGenderMatch;
        });

        setOverallFilteredResults([...filtered])
    }

    const getGlobalTopRiders = async () => {
        const res = await GetGlobalTopRiders()

        if (!res || !res?.data) { return }

        const riderData = res.data[1].data
        const top5 = riderData.slice(0, 5)
        const chartData = top5.map(rider => ({
            name: rider.riderName,
            value: rider.count,
        }))

        setTopRiderData(res.data[1])
        setTopRiderChartData(chartData)
        console.log(chartData)
    }

    const COLORS = ['#011f4b', '#03396c', '#005b96', '#6497b1', '#b3cde0'];

    useEffect(() => {
        getUserLeagues()
        getNextEvent()
        getEvents()
        getResults()
        getEditingDisabled()
        getOverallStandings()
        // getGlobalTopRiders()
    }, []);



    // const renderActiveShape = (props) => {
    //     const RADIAN = Math.PI / 180;
    //     const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value, name } = props;
    //     const sin = Math.sin(-RADIAN * midAngle);
    //     const cos = Math.cos(-RADIAN * midAngle);
    //     const sx = cx + (outerRadius + 10) * cos;
    //     const sy = cy + (outerRadius + 10) * sin;
    //     const mx = cx + (outerRadius + 30) * cos;
    //     const my = cy + (outerRadius + 30) * sin;
    //     const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    //     const ey = my;
    //     const textAnchor = cos >= 0 ? 'start' : 'end';

    //     return (
    //         <g>

    //             <Sector
    //                 cx={cx}
    //                 cy={cy}
    //                 innerRadius={innerRadius}
    //                 outerRadius={outerRadius}
    //                 startAngle={startAngle}
    //                 endAngle={endAngle}
    //                 fill={fill}
    //             />
    //             <Sector
    //                 cx={cx}
    //                 cy={cy}
    //                 startAngle={startAngle}
    //                 endAngle={endAngle}
    //                 innerRadius={outerRadius + 6}
    //                 outerRadius={outerRadius + 10}
    //                 fill={fill}
    //             />
    //             <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
    //             <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
    //             <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`${name}`}</text>
    //             <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
    //                 {`(Count ${value})`}
    //             </text>
    //         </g>
    //     );
    // };

    useEffect(() => {
        const timer = setInterval(() => {
            const newTimeRemaining = getTimeRemaining();
            setTimeRemaining(newTimeRemaining);

            if (newTimeRemaining.timeDifference <= 0) {
                if (!editingDisabled) {
                    DisableEditing();
                }
                clearInterval(timer);
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [timeRemaining]);


    const onPieEnter = (_, index) => {
        setTopRiderActiveIndex(index)
    }


    const renderResults = (result, index, type) => {
        return (
            <>
                {
                    result.eventId == event._id &&
                    <tr key={index}>
                        <td style={{ fontSize: '14px' }}>{index + 1}</td>
                        <td style={{ fontSize: '14px' }}>{result.rider_first_name} <b>{result.rider_last_name}</b></td>
                        {type == 'Overall' && <td className="d-flex justify-content-between" style={{ fontSize: '14px' }}>{result.total_points}</td>}
                        {type == 'Qualifying' && <td className="d-flex justify-content-between" style={{ fontSize: '14px' }}>{result.qualifying_points}</td>}
                        {type == 'Semis' && <td className="d-flex justify-content-between" style={{ fontSize: '14px' }}>{result.semis_points}</td>}
                        {type == 'Finals' && <td className="d-flex justify-content-between" style={{ fontSize: '14px' }}>{result.finals_points}</td>}
                    </tr>
                }
            </>
        )
    }

    const renderOverallResults = (result, index) => {
        return (
            <>
                {
                    <tr key={index}>
                        <td style={{ fontSize: '14px' }}>{index + 1}</td>
                        <td style={{ fontSize: '14px' }}>{result.rider_first_name} <b>{result.rider_last_name}</b></td>
                        <td className="d-flex justify-content-between" style={{ fontSize: '14px' }}>{result.total_points}</td>
                    </tr>
                }
            </>
        )
    }

    const renderEventCards = (_event, index) => {
        const country = _event.location.match(/\((.*?)\)/)[0];

        const inPast = new Date() > new Date(_event?.date) ? true : false;
        const isNext = _event?.location == nextEvent?.location ? true : false;

        const backgroundColor = inPast ? '#fcffff' : '#ebebeb'
        return (
            <>
                {
                    !isNext ? <Card key={index} border='none' className="mx-2 my-2 shadow border-0" text={inPast ? 'dark' : 'secondary'} style={{ width: '370px', minWidth: '330px', backgroundColor: `${backgroundColor}` }}>
                        <Card.Body>
                            <Card.Title className="fs-6 pb-0 mb-0">

                                <div className="d-flex align-items-center justify-content-between" >

                                    <div className="">  {!inPast && <AiOutlineLock className="me-1 mb-1"></AiOutlineLock>}{_event?.location.split('(')[0].trimLeft()}</div>
                                    {inPast && <Button variant='secondary' style={{ fontSize: '14px' }} onClick={() => { setEvent(_event); setShowResults(true); handleFilter(genderFilter, pointsFilter, _event._id) }} className="py-0 fw-light"><FaFlagCheckered className="mb-1 me-1" /> View Results</Button>}
                                </div>
                            </Card.Title>
                            <Card.Text className="fw-light" style={{ fontSize: '14px' }}>
                                <div className="">{country}</div>
                                <div className="">Start date: {formatDate(_event?.date)} </div>
                            </Card.Text>

                        </Card.Body>
                    </Card>
                        :
                        <Card key={index} className="mx-2 my-2" text='dark' border='primary' style={{ width: '370px', minWidth: '330px' }}>
                            <Card.Body>
                                <Card.Title className="fs-6 fw-bolder pb-0 mb-1">
                                    <div className="d-flex align-items-center justify-content-between align-items-center" >
                                        <div className="d-flex align-items-center">{_event?.location.split('(')[0].trimLeft()}</div>
                                        <div className="rounded-pill px-3  py-1 d-flex align-items-center fw-light" style={{ backgroundColor: '#25b3bd', color: 'white', fontSize: '12px' }}>
                                            <FaCircle className="me-1" />
                                            UPCOMING
                                        </div>
                                    </div>
                                </Card.Title>
                                <Card.Text className="fw-light" style={{ fontSize: '14px' }}>
                                    <div className="">{country}</div>
                                    <div className="">Start date: {formatDate(_event?.date)}</div>
                                </Card.Text>
                            </Card.Body>
                        </Card>}
            </>

        )
    }


    const renderLeagues = (league, index) => {

        let matchingTeam = {}
        if (user && 'teams' in user) {
            matchingTeam = user.teams.find((team) => team.leagueId === league._id);
        }
        const teamId = matchingTeam ? matchingTeam.teamId : null

        return (
            <div className="" key={index}>
                <Card className="mx-3 my-4 border-0 shadow">
                    <Card.Header as="h5" className="fs-6"><FaUsers className="mb-1 me-1" /> {league.name}</Card.Header>
                    <Card.Body>
                        {league && 'private' in league && league.private &&
                            <div className="my-2 mb-3">
                                <InfoIcon></InfoIcon>
                                <Form.Label className="mt-1 fw-bold" style={{ fontSize: '14px' }}> League Url:</Form.Label>
                                <div className="row">
                                    <div className="col-md"> <Form.Control type='text' className='fw-light' style={{ fontSize: '14px' }} disabled readOnly value={`${URL}/Login?leagueId=${league._id}`} ></Form.Control></div>
                                    <div className="col-md-2 py-2 py-sm-0">
                                        <Button variant="secondary" className='mt-md-0 w-100' style={{ fontSize: '14px' }} onClick={() => copyURL(`${URL}/Login?leagueId=${league._id}`)}><FiCopy></FiCopy> Copy URL</Button>
                                    </div>
                                </div>
                            </div>}
                        <div className="" style={{ fontSize: '15px' }}>{league.description}</div>
                        {/* <hr></hr> */}
                        <div className="row mt-3">
                            <div className="col-lg-6 ">
                                <div className="d-flex flex-row justify-content-start">
                                    <div className="">
                                        <div className="fw-light" style={{ fontSize: '14px' }}>Next Event: {formatDate(nextEvent.date)}</div>
                                        <div className="fw-light" style={{ fontSize: '14px' }}>Players in League: {league.teams.length}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="row d-flex flex-row justify-content-end">
                                    <div className="col-md-3 col-12 p-0 d-flex align-items-center justify-content-center">
                                        <Button className='mt-2 mx-md-2 ms-2 w-100' disabled={editingDisabled} variant="outline-secondary" style={{ fontSize: '14px' }} onClick={() => editMyTeam(teamId, league._id)}><FiEdit size={20} className="mb-1 me-2"></FiEdit>Edit Team</Button>
                                    </div>
                                    <div className="col-md-3 col-12  p-0 d-flex align-items-center justify-content-center">
                                        <Button className='mt-2 mx-md-2 ms-2 w-100' variant="primary" style={{ fontSize: '14px' }} onClick={() => goToLeague(league._id)}><RxEnter size={20} className="mb-1 me-2"></RxEnter>View Team</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        )
    }

    return (
        <div className="container container-background pb-5 py-3" style={{ minHeight: '100vh' }}>
            <Helmet>
                <title>Dashboard - 2023 Downhill MTB Fantasy</title>
                <meta name="description" content="View your dashboard and manage your fantasy teams. Stay up to date with the latest downhill mountain biking results and rankings." />
            </Helmet>
            <div className="banner-ad" onClick={() => navigate('/rampage')}> 
                <img
                    className="mobile-image hidden-on-desktop mb-3"
                    src={WIN_Mobile}
                    alt="Desktop Ad"
                    
                />
                <img
                    className="desktop-image hidden-on-mobile"
                    src={WIN}
                    alt="Mobile Ad"
                />
            </div>

            <div className={`d-flex webkit-scrollbar`} style={{ height: '120px', overflowX: 'scroll' }} >
                {Array.isArray(events) && events.map(renderEventCards)}
            </div>

            <div className="d-flex flex-row justify-content-center mb-5 mt-5">
                <Card className="normal-countdown-card border-white" text='light' bg='dark' style={{ maxWidth: '400px', minWidth: '360px' }}>
                    <Card.Body>
                        <div className="text-center fs-5 fw-bolder mb-2">{nextEvent?.location}</div>
                        <div className="row">
                            <div className="col-3 fw-lighter text-center">Days</div>
                            <div className="col-3 fw-lighter text-center">Hours</div>
                            <div className="col-3 fw-lighter text-center">Minutes</div>
                            <div className="col-3 fw-lighter text-center">Seconds</div>
                        </div>
                        <div className="row">
                            <div className="col-3 text-center fw-bold">{timeRemaining.days}</div>
                            <div className="col-3 text-center fw-bold">{timeRemaining.hours}</div>
                            <div className="col-3 text-center fw-bold">{timeRemaining.minutes}</div>
                            <div className="col-3 text-center fw-bold">{timeRemaining.seconds}</div>
                        </div>
                    </Card.Body>
                    <div className="fw-light mb-0 d-flex justify-content-center">*Time until team editing is locked</div>
                    <div className="fw-lighter mb-3 d-flex justify-content-center"> (Elite Qualifying)</div>

                </Card>
            </div>
            <div className="row d-flex flex-row justify-content-center mt-2 ms-2 ms-sm-5 mb-3 text-muted">
                <div className="col-sm text-sm-end ps-4" style={{ fontSize: '14px' }}>Follow on Instagram for team update reminders:</div>
                <div className="col-sm text-start">
                    <Button variant='link' className="pt-sm-0 ps-sm-0" style={{ fontSize: '14px' }} onClick={handleInstagramClick}>
                        <FiInstagram /> downhillmtbfantasy
                    </Button></div>
            </div>

            <div className="line-with-title-container mt-4">
                <hr></hr>
                <div className="title">Current Standings</div>
            </div>

            {/* <div className="" style={{ width: '100%', height: '300px' }}>
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart width={500} height={500}>
                        <Pie
                            activeIndex={topRiderActiveIndex}
                            activeShape={renderActiveShape}
                            data={topRiderChartData}
                            cx="50%"
                            cy="50%"
                            innerRadius={50}
                            outerRadius={80}
                            fill="#8884d8"
                            dataKey="value"
                            // label={(entry) => entry.name}
                            onMouseEnter={onPieEnter}
                        >
                            {topRiderChartData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                    </PieChart>
                </ResponsiveContainer>
            </div> */}

            <div className="mx-3 my-4 py-3 pb-4">
                <Card className=" border-0 shadow">
                    <Card.Header as="h5" className="py-3"> <GiPodiumWinner className="mb-1 me-2" /> 2023 Overall Points</Card.Header>
                    <Card.Body className="mx-md-3 mb-md-3 mx-1 mb-1" >
                        <Tabs
                            defaultActiveKey="Male"
                            id="uncontrolled-tab-example"
                            className="mb-3"
                            onSelect={(e) => handleOverallFilter(e)}
                        >
                            <Tab eventKey="Male" title="Elite Male" onClick={() => handleOverallFilter("Male")} style={{ maxHeight: '10rem', overflow: 'scroll' }}>
                                <Table responsive="sm" striped bordered hover className="px-5 border-white" >
                                    <thead>
                                        <tr>
                                            <th>Place</th>
                                            <th>Name</th>
                                            <th>Points</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(overallFilteredResults) && overallFilteredResults.map((result, index) => renderOverallResults(result, index))}
                                    </tbody>
                                </Table>
                            </Tab>
                            <Tab eventKey="Female" title="Elite Female" onClick={() => handleOverallFilter("Female")} style={{ maxHeight: '10rem', overflow: 'scroll' }}>
                                <Table responsive="sm" striped bordered hover className="px-5 border-white" >
                                    <thead>
                                        <tr>
                                            <th>Place</th>
                                            <th>Name</th>
                                            <th>Points</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(overallFilteredResults) && overallFilteredResults.map((result, index) => renderOverallResults(result, index, 'Overall'))}
                                    </tbody>
                                </Table>
                            </Tab>

                        </Tabs>
                    </Card.Body>
                </Card>
            </div>


            <div className="line-with-title-container mt-4">
                <hr></hr>
                <div className="title">My Leagues</div>
            </div>
            {leagues.length != 0 &&
                <div className="pt-1">
                    {Array.isArray(leagues) && leagues.map(renderLeagues)}
                </div>
            }
            {
                leagues.length == 0 && user?.teams != undefined && user?.teams.length == 0 &&
                <div className="mx-3 my-4 py-3 pb-4">
                    <Card className="border-0 shadow">
                        <Card.Header as="h5" className="py-3">Downhill MTB Fantasy</Card.Header>
                        <Card.Body>
                            <Card.Title className="px-3 py-2">Ready to join the action?</Card.Title>
                            <Card.Text className="px-3">
                                <div className="mb-2">Welcome to Downhill Mountain Biking Fantasy, a passion project dedicated to tracking the UCI Downhill World Cup season. </div>
                                <div className="">Join us to create and compete in public or private leagues, invite your friends, and enjoy the 2023 World Cup Seaon.</div>
                            </Card.Text>
                            <Button variant="primary" className="mx-3 my-2" onClick={JoinGlobalLeague}>Join Global League</Button>
                            <hr></hr>
                            <Card.Text className="px-3 py-2">
                                Alternatively, you can explore the "Leagues" tab to find other leagues and compete on a more local scale.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </div>
            }
            <Modal size='lg' show={showResults} onHide={() => setShowResults(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Results for Event: {event?.location}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row my-2 mb-3">
                        <div className="col-sm-1 me-4 d-flex align-items-center">Category:</div>
                        <div className="col-sm d-flex justify-content-start">
                            <DropdownButton size='md' className="" onChange={(e) => handleFilter(e.target.value)} id="dropdown-basic-button" variant='outline-secondary' title={genderFilter} >
                                <Dropdown.Item value='Male' onClick={(e) => handleFilter(e.target.text, pointsFilter, event._id)}>Male</Dropdown.Item>
                                <Dropdown.Item value='Female' onClick={(e) => handleFilter(e.target.text, pointsFilter, event._id)}>Female</Dropdown.Item>
                            </DropdownButton>
                        </div>
                    </div>


                    <Tabs
                        defaultActiveKey="Overall"
                        id="uncontrolled-tab-example"
                        className="mb-3"
                        onSelect={(e) => handleFilter(genderFilter, e, event._id)}
                    >
                        <Tab eventKey="Overall" title="Overall">
                            <Table responsive="sm" striped bordered hover className="px-5">
                                <thead>
                                    <tr>
                                        <th>Place</th>
                                        <th>Name</th>
                                        <th>Points</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(filteredResults) && filteredResults.map((result, index) => renderResults(result, index, 'Overall'))}
                                </tbody>
                            </Table>

                        </Tab>
                        <Tab eventKey="Qualifying" title="Qualifying" onClick={() => handleFilter(genderFilter, 'Qualifying')}>
                            <Table responsive="sm" striped bordered hover className="px-5">
                                <thead>
                                    <tr>
                                        <th>Place</th>
                                        <th>Name</th>
                                        <th>Points</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(filteredResults) && filteredResults.map((result, index) => renderResults(result, index, 'Qualifying'))}
                                </tbody>
                            </Table>
                        </Tab>
                        <Tab eventKey="Semis" title="Semi Finals">
                            <Table responsive="sm" striped bordered hover className="px-5">
                                <thead>
                                    <tr>
                                        <th>Place</th>
                                        <th>Name</th>
                                        <th>Points</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(filteredResults) && filteredResults.map((result, index) => renderResults(result, index, 'Semis'))}
                                </tbody>
                            </Table>
                        </Tab>
                        <Tab eventKey="Finals" title="Finals">
                            <Table responsive="sm" striped bordered hover className="px-5">
                                <thead>
                                    <tr>
                                        <th>Place</th>
                                        <th>Name</th>
                                        <th>Points</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(filteredResults) && filteredResults.map((result, index) => renderResults(result, index, 'Finals'))}
                                </tbody>
                            </Table>
                        </Tab>
                    </Tabs>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowResults(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default Dashboard;